import IconTooltip from 'components/iconTooltip/IconTooltip';
import { cardIconButtonClass } from './PanelCard';

/**
 * The icon-only button of a card or a panel (edit, delete, remove, resend…):
 * the 32 px bordered square of `cardIconButtonClass`, named by its tooltip.
 * `label` is the tooltip and the aria-label, unless `ariaLabel` says more for
 * a screen reader (« Retirer Paul de SAFO » where the tooltip reads « Retirer
 * de SAFO »). `icon`: the icon element, 18 px. Other props (onKeyDown…) go to
 * the button.
 */
const CardIconButton = ({ icon, label, ariaLabel, className = '', ...buttonProps }) => (
  <IconTooltip label={label}>
    <button
      type="button"
      aria-label={ariaLabel ?? label}
      className={`${cardIconButtonClass} disabled:cursor-not-allowed disabled:opacity-40 ${className}`}
      {...buttonProps}
    >
      {icon}
    </button>
  </IconTooltip>
);

export default CardIconButton;
